var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('iv-input-tree-select',_vm._g(_vm._b({},'iv-input-tree-select',{
        ..._vm.$attrs,
        ..._vm.$props,
        quicks: _vm.generatedQuicks,
        value: _vm.generatedValue,
    },false),{
        'update:value': _vm.handleInput,
    }))
}
var staticRenderFns = []

export { render, staticRenderFns }